export const meta = { id: 'O19', slug: 'organizar-sequencia-jornada', title: 'Como organizar a sequência de uma Jornada', description: 'Ordene experiências de desenvolvimento de acordo com a lógica do percurso.', profile: 'owner', category: 'jornadas', type: 'task', status: 'published', order: 490, keywords: ['sequência jornada','ordem','percurso','desenvolvimento'], previous: 'O18', next: 'O20', related: ['O17','O18','A05'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como organizar a sequência de uma Jornada

A sequência deve fazer sentido para o desenvolvimento, não apenas para a organização da tela.

Uma lógica útil é:

**Entender → Praticar → Demonstrar → Receber acompanhamento → Evoluir**

<HelpImage pendingId="O19.1" alt="Estrutura e sequência de uma Jornada" />

<Callout type="tip">Revise se cada experiência prepara o participante para a próxima e se o botão ou ação de continuidade aponta para um passo realmente coerente.</Callout>
